import {Alert, AlertDescription} from '@/components/ui/alert.tsx';
import {Empty, EmptyDescription, EmptyHeader, EmptyTitle} from '@/components/ui/empty.tsx';
import {Skeleton} from '@/components/ui/skeleton.tsx';
import {SalesDynamicsChart} from '../sales-dynamics-page/sales-dynamics-chart';
import {SalesDynamicsSummary} from '../sales-dynamics-page/sales-dynamics-summary';
import {useProductPageContext} from './product-context';

export function ProductSalesPage() {
	const state = useProductPageContext();
	if (!state.product?.ozonSku) {
		return (
			<Empty className="border border-border">
				<EmptyHeader>
					<EmptyTitle>Нет SKU Ozon</EmptyTitle>
					<EmptyDescription>Динамику продаж для этого товара посчитать нельзя</EmptyDescription>
				</EmptyHeader>
			</Empty>
		);
	}
	const oosDays = state.salesDynamics?.statistics.filter((day) => day.inStock === 0).length ?? 0;
	return (
		<section className="flex flex-col gap-4">
			<h2 className="text-base font-medium">Продажи</h2>
			{state.salesDynamicsError ? (
				<Alert variant="destructive">
					<AlertDescription>{state.salesDynamicsError}</AlertDescription>
				</Alert>
			) : null}
			{state.salesDynamicsLoading ? <Skeleton className="h-72 w-full"/> : null}
			{state.salesDynamics ? (
				<div className="flex flex-col gap-4">
					<SalesDynamicsSummary summary={state.salesDynamics.summary}/>
					<SalesDynamicsChart statistics={state.salesDynamics.statistics}/>
					<p className="text-sm text-muted-foreground">
						{oosDays > 0 ? `Дней без остатка: ${oosDays}.` : 'Дней без остатка в выбранном периоде нет.'}
					</p>
					{state.salesDynamics.warnings.map((warning) => (
						<p key={warning} className="text-sm text-muted-foreground">{warning}</p>
					))}
				</div>
			) : null}
		</section>
	);
}
